/**
 * Clasificación de workspace (SCRUM-294) compartida entre superficies admin.
 * Espejo intencional de la función homónima en PlatformAdminPage.tsx (no se
 * unificaron para no tocar ese archivo/tests ya cerrados) — misma lógica.
 */
export type WorkspaceKind = "client" | "demo_seed" | "demo_lead";

export function getWorkspaceKind(productFlags?: Record<string, boolean>): WorkspaceKind {
  if (productFlags?.is_demo_lead) return "demo_lead";
  if (productFlags?.is_demo_seed || productFlags?.is_demo) return "demo_seed";
  return "client";
}

export const WORKSPACE_KIND_LABELS: Record<WorkspaceKind, string> = {
  client: "Cliente",
  demo_seed: "Demo con seed",
  demo_lead: "Demo por lead",
};
